export const categories = {
  DISCOVER: 'Discover',
};

export const gaParams = {
  pageType: 'page_type',
};
